import { render, staticRenderFns } from "./DeliveryPointsTable.vue?vue&type=template&id=02e5b3b6&scoped=true&"
import script from "./DeliveryPointsTable.vue?vue&type=script&lang=ts&"
export * from "./DeliveryPointsTable.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryPointsTable.vue?vue&type=style&index=0&id=02e5b3b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e5b3b6",
  null
  
)

export default component.exports